enum StoreActions {
  REDIRECT_TO = 'REDIRECT/REDIRECT_TO',
}

export const ActionTypes_Redirect = {
  StoreActions,
}
